
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export const CartValidation = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex items-start gap-2 p-4 text-sm border rounded bg-muted/50">
      <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0 text-blue-500" />
      <div className="space-y-2">
        <Button 
          variant="link" 
          className="p-0 h-auto font-medium text-sm text-blue-600 hover:text-blue-700"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          Cliquez ici pour en savoir plus sur la signature numérique
        </Button>
        
        {isExpanded && (
          <div className="space-y-2">
            <p>
              La signature numérique est un code secret personnel qui identifie chaque vendeur. 
              Voici comment ça marche :
            </p>
            <ul className="list-disc pl-4 space-y-1">
              <li>Le propriétaire doit donner à chaque vendeur un code unique (par exemple : "VENDEUR123")</li>
              <li>Ce code secret servira de signature pour toutes les ventes du vendeur</li>
              <li>Cette signature permet de suivre qui a fait quelle vente</li>
              <li>Une vente sans signature valide ne sera pas autorisée</li>
            </ul>
            <p className="text-xs text-muted-foreground mt-2">
              NB : Le mode de paiement est obligatoire uniquement pour les ventes standards ou les ventes à crédit avec un paiement partiel.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
